import { render, staticRenderFns } from "./SymptomChecker.vue?vue&type=template&id=7811cef4&"
import script from "./SymptomChecker.vue?vue&type=script&lang=js&"
export * from "./SymptomChecker.vue?vue&type=script&lang=js&"
import style0 from "./SymptomChecker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports